const BelgiumFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="10" height="20" fill="#000000"/>
    <rect x="10" width="10" height="20" fill="#FFD500"/>
    <rect x="20" width="10" height="20" fill="#EF3340"/>
  </svg>
);

export default BelgiumFlag;